import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard  {

  constructor(
    protected router: Router,
    private permissionService: PermissionService
  ) { }


  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    if (!route.data.hasOwnProperty('module')) {
      console.log('[PERMISSION_GUARD] no module in route data, allow');
      return true;
    }

    const moduleName = route.data.module;
    console.log('[PERMISSION_GUARD] checking module', moduleName);
    const actions = await this.permissionService.loadActions(moduleName);
    console.log('[PERMISSION_GUARD] module actions loaded', { moduleName, actionsCount: actions.length, actions });
    if (actions.length > 0) {
      console.log('[PERMISSION_GUARD] allow', moduleName);
      return true;
    }

    console.warn('[PERMISSION_GUARD] deny -> /no-access', moduleName);
    return this.router.parseUrl('/no-access');
  }

}
